module.exports = __webpack_public_path__ + "static/img/kefu.47704d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kefu.png
// module id = mjJX
// module chunks = 1